<template>
  <div class="bar" :style="{ bottom: `${bar.bottom}px` }">
    <div
      v-for="part of bar.data"
      :key="part.label"
      class="part-of-bar"
      :class="part.class"
      :style="{
        background: part.color,
        width: `${bar.width}px`,
        height: `${getHeight(part.value)}px`
      }"
    >
      <LmTooltip v-if="showValuesOnHover">
        <div class="text-body-3">
          {{ formatPrice(part.value) }} <small>{{ settings.currency }}</small>
        </div>
      </LmTooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bar: {
      type: Object,
      required: true
    },

    showValuesOnHover: Boolean,

    getHeight: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.bar {
  position: relative;
  z-index: 1;
  transform: scaleY(0);
  animation: scale-up 0.7s ease-in-out forwards;
  transform-origin: bottom;

  .part-of-bar {
    transition: height 0.7s ease-in-out;
  }
}

@keyframes scale-up {
  to {
    transform: scaleY(1);
  }
}
</style>
